import { render, staticRenderFns } from "./ContainView.vue?vue&type=template&id=b137f442"
import script from "./ContainView.vue?vue&type=script&lang=js"
export * from "./ContainView.vue?vue&type=script&lang=js"
import style0 from "./ContainView.vue?vue&type=style&index=0&id=b137f442&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports